import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH AFFILIATE PARTNER TO EDIT ********************
export const fetchAffiliatePartner = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_AFFILIATE_PARTNER_LOADING,
			payload: true
		});

		const { data } = await services.get(`/affiliate/${id}`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_AFFILIATE_PARTNER_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_AFFILIATE_PARTNER_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** FETCH AFFILIATE PARTNER CODES ********************
export const fetchAffiliatePartnerCodes = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_AFFILIATE_PARTNER_CODES_LOADING,
			payload: true
		});

		const { data } = await services.get(`/affiliate/${id}/codes`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_AFFILIATE_PARTNER_CODES_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_AFFILIATE_PARTNER_CODES_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** DELETE AFFILIATE PARTNER CODES ********************
export const deleteAffiliatePartnerCode = (itemID, code) => async (
	dispatch
) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.DELETE_AFFILIATE_PARTNER_CODES_LOADING,
			payload: true
		});

		await services.delete(`/affiliate/${itemID}/codes/${code}`);
		// Dispatch an action with data
		dispatch({
			type: types.DELETE_AFFILIATE_PARTNER_CODES_SUCCESS,
			payload: true
		});
	} catch (error) {
		// Dispatch an action with error set to true
		dispatch({
			type: types.DELETE_AFFILIATE_PARTNER_CODES_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
